import http from "../http-common-2";

class ManoshalaCareService {
  getCares(token:any) {
    return http.get(`/manoshalacare`,{
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  updateStatus(id:any,status:any) {
    return http.patch(`/manoshalacare/${id}?status=${status}`);
  }
}
export default new ManoshalaCareService();
